import { useLayoutEffect, useRef, useState } from "react";

export const TABLE_STYLES = {
  headRow: {
    style: { minHeight: "38px", backgroundColor: "#f8f9fb", borderBottomColor: "#eef0f3" },
  },
  headCells: {
    style: {
      fontSize: "0.72rem",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.03em",
      color: "#6c757d",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
  },
  rows: {
    style: { minHeight: "48px", fontSize: "0.85rem" },
    denseStyle: { minHeight: "40px" },
  },
  cells: {
    style: { paddingLeft: "10px", paddingRight: "10px" },
  },
  pagination: {
    style: { borderTopColor: "#eef0f3", minHeight: "48px" },
  },
};

/** Height of the app's fixed top bar, so a sticky table header can sit right below it. */
const fixedHeaderBottom = () => {
  const header = document.querySelector(".page-header");
  if (!header) return 0;
  const { position } = window.getComputedStyle(header);
  if (position !== "fixed" && position !== "sticky") return 0;
  return Math.max(Math.round(header.getBoundingClientRect().bottom), 0);
};

/**
 * The table flows with the page (no inner scroll box); its column header sticks below the app bar.
 * Returns a ref and a style object to put on the element wrapping the DataTable.
 */
export function useStickyTableHeader() {
  const ref = useRef(null);
  const [top, setTop] = useState(0);

  useLayoutEffect(() => {
    const measure = () => {
      const next = fixedHeaderBottom();
      setTop((current) => (current === next ? current : next));
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return [ref, { "--gl-sticky-top": `${top}px` }];
}
